import { JSX, useState } from "react";
import { useTranslation } from "react-i18next";

import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import { Box, Button } from "@mui/material";

import { BomAndSummaryDialog } from "./BomAndSummaryDialog";

export function BomAndSummaryBtn({
  disabled,
}: {
  disabled?: boolean;
}): JSX.Element {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <Box mr="auto" padding="0.5rem" paddingLeft="0px" display="flex">
      {open && (
        <BomAndSummaryDialog open={open} handleClose={() => setOpen(false)} />
      )}

      <Button
        variant="contained"
        startIcon={<ListAltOutlinedIcon />}
        onClick={() => setOpen(true)}
        disabled={disabled}
      >
        {t("AS:footer.button.billOfMaterials")}
      </Button>
    </Box>
  );
}
